export default {
  border: true,
  rounded: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  cursor: 'pointer',
  fareBodyItem: {
    alignItems: 'center',
    height: '100',
    paddingWidth: '2',
    paddingBottom: '2',
  },
  showBackgroundImage: false,
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
  },
  showDate: true,
  fareItemDate: {
    textTransform: 'uppercase',
    fontSize: '5',
    paddingTop: '2',
    paddingBottom: '1',
    yearStyles: {
      fontWeight: 'light',
    },
  },
  fareItemTripDuration: {
    paddingBottom: '1',
  },
  showOriginDestination: false,
  showHorizontalSeparator: true,
  fareItemHorizontalSeparator: {
    borderTop: true,
    borderWidth: '1',
    paddingBottom: '2',
    width: '25',
    borderColor: 'secondary',
  },
  showPrice: false,
  showMiles: true,
  fareItemMiles: {
    milesPromoLabelKey: 'fare_promo_label-promo-short',
    milesSymbol: 'miles',
    paddingBottom: '1',
    textAlign: 'center',
    style: { lineHeight: '1' },
    milesPromoStyles: {
      display: 'block',
      fontWeight: 'light',
      textTransform: 'uppercase',
      marginBottom: '2px',
      fontSize: '10px',
    },
    amountStyles: {
      display: 'inline-block',
      fontSize: '5',
    },
    taxAmountStyles: {
      display: 'inline-block',
      paddingLeft: '1',
    },
    milesSymbolStyles: {
      paddingLeft: '1',
    },
    taxAmountSymbolStyles: {
      paddingRight: '1',
    },
  },
  fareItemLastSeen: {
    dateStyles: {
      fontWeight: 'light',
    },
  },
  showDepartureReturnBeforePrice: true,
  fareItemDepartureReturn: {
    display: 'flex',
    paddingBottom: '2',
  },
  fareItemDepartureInfo: {
    showDepartureText: true,
    showDepartureDate: true,
    departureText: 'cmp-label--departure-date-colon',
    fontWeight: 'light',
    departureTextLabelStyle: {
      fontWeight: 'bold',
    },
  },
  separatorDatesProps: {
    content: 'minus',
  },
  showReturnInfo: true,
  fareItemReturnInfo: {
    showReturnText: true,
    showReturnDate: true,
    returnText: 'cmp-label--return-date-colon',
    fontWeight: 'light',
    returnTextLabelStyles: {
      fontWeight: 'bold',
    },
  },
  fareItemJourneyTypeTravelClass: {
    display: 'flex',
  },
  fareItemNoPriceAvailable: {
    showIcon: false,
    alignItems: 'center',
    marginTop: 'auto',
    messageStyles: {
      paddingBottom: '40px',
      fontWeight: 'light',
      width: '75',
    },
    showLinkAvailability: true,
    linkAvailabilityStyles: {
      padding: '0',
      fontWeight: 'bold',
      fontSize: '3',
      textColor: 'black',
      textTransform: 'uppercase',
      style: { textDecoration: 'underline' },
    },
  },
};
